<div class="hint-dialog">
  <div class="hint">
    @if (isEmpty) {
    <p><span [ghs-label]="'round.hint.empty'"></span></p>
    }
    @if (isMissingInitiative) {
    <p><span [ghs-label]="'round.hint.missingInitiative'"></span> </p>
    }
    @if (isActive) {
    <p><span [ghs-label]="'round.hint.active'"></span></p>
    }
    @if (isActive) {
    <a (click)="confirm()"><span [ghs-label]="'round.hint.confirm'"></span></a>
    }
    @if (isActive) {
    <a (click)="next()" class="small"><span [ghs-label]="'round.hint.confirmTurns'"></span></a>
    }
    @if (isFinish) {
    <p><span [ghs-label]="'round.hint.finish'"></span></p>
    }
    @if (isFinish) {
    <a (click)="finishScenario(true)"><span [ghs-label]="'round.hint.confirmFinish'"></span></a>
    }
    @if (isFailed) {
    <p><span [ghs-label]="'round.hint.failed'"></span></p>
    }
    @if (isFailed) {
    <a (click)="finishScenario(false)"><span [ghs-label]="'round.hint.confirmFailed'"></span></a>
    }
    @if (isFailed) {
    <a (click)="resetScenario()"><span [ghs-label]="'round.hint.confirmReset'"></span></a>
    }
    @if (isFinish || isFailed) {
    <a (click)="confirm()"><span [ghs-label]="(gameManager.game.state == GameState.next ?
      'round.hint.continueNext' : 'round.hint.continueDraw')"></span></a>
    }
    @if (isBattleGoals) {
    <p><span [ghs-label]="'round.hint.battleGoals'"></span></p>
    }
    @if (isBattleGoals) {
    <a (click)="confirm()"><span [ghs-label]="'round.hint.confirm'"></span></a>
    }
    @if (isEventDraw && gameManager.game.eventDraw) {
    <p><span [ghs-label]="'round.hint.eventDraw'" [ghs-label-args]="[gameManager.game.eventDraw]"></span></p>
    }
    @if (isEventDraw) {
    <a (click)="confirm()"><span [ghs-label]="'round.hint.confirm'"></span></a>
    }
    @if (missingMonsterAbility()) {
    <p><span [ghs-label]="'round.hint.missingMonsterAbility'"></span></p>
    }
  </div>
</div>